import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

const WHITE_LISTED_DOMAINS = ['@uvx.ai'];

export function useUVXFeaturesAccess() {
  const currentUser = useMapGetter('getCurrentUser');
  const currentAccountId = useMapGetter('getCurrentAccountId');
  const isFeatureEnabledonAccount = useMapGetter(
    'accounts/isFeatureEnabledonAccount'
  );

  const hasUVXFeaturesAccess = computed(() => {
    if (
      isFeatureEnabledonAccount.value(
        currentAccountId.value,
        FEATURE_FLAGS.WGPT_UVX_FEATURES_ACCESS
      )
    ) {
      return true;
    }
    const { email = '' } = currentUser.value ?? {};
    return WHITE_LISTED_DOMAINS.some(domain => email.endsWith(domain));
  });

  return {
    hasUVXFeaturesAccess,
  };
}
